import {
  ConversationDirection,
  ConversationStatus,
} from 'lib-shared-legacy-types';

export const CONVERSATION_DIRECTION_INBOUND: ConversationDirection = 'inbound';
export const CONVERSATION_DIRECTION_OUTBOUND: ConversationDirection =
  'outbound';
export const CONVERSATION_DIRECTION_BOTH: ConversationDirection = 'internal';
export const CONVERSATION_STATUS_NONE: ConversationStatus = 'closed';
export const CONVERSATION_STATUS_ACTIVE: ConversationStatus = 'open';
export const CONVERSATION_STATUS_PENDING: ConversationStatus = 'pending';
export const CONVERSATION_STATUS_AWAITING_PENDING: ConversationStatus =
  'awaitingpending';
